import './src/styles/global.css'

// Fixes a weird bug where scroll positions are not reset when navigating
export const shouldUpdateScroll = ({ routerProps }) => {
  const hasAnchor = !!routerProps.location.hash
  return hasAnchor
}
